import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { fetchActiveInfo } from "@Services/api";

interface ArticleaLeftActiveImgProps {}

const Content: React.FC<ArticleaLeftActiveImgProps> = (props: ArticleaLeftActiveImgProps) => {
  const [randomImage, setRandomImage] = useState<{ img: string; title: string }>({ img: "", title: "string" });

  const getActiveData = async () => {
    try {
      const res: { data; status } = await fetchActiveInfo({ name: "inquiry-sale" });
      if (res.status === 12000) {
        res.data.activityStatus === 1 && getRandomImage();
      }
    } catch (error) {}
  };

  const getRandomImage = () => {
    const image = [
      { img: "https://photo.8891.com.tw/2024/04/11/1712827527555044.png", title: "100萬 真補貼" },
      { img: "https://photo.8891.com.tw/2024/04/11/1712827527563578.png", title: "8891百萬補貼" },
      { img: "https://photo.8891.com.tw/2024/04/11/1712827527565863.png", title: "8891下訂補貼" },
    ];
    const randomIndex = Math.floor(Math.random() * image.length);
    setRandomImage(image[randomIndex]);
  };

  useEffect(() => {
    getActiveData();
  }, []);

  return (
    <a href='/buyCar' data-title={randomImage.title} id="ActiveTagTitle">
      <img
        src={randomImage.img}
        alt=''
        style={{ width: "88px", height: "82px", objectFit: "cover", position: "relative", left: "-25px", top: "25px" }}
      />
    </a>
  );
};

export default Content;

const $app = document.getElementById("articleLeft-activeImg");
!!$app && ReactDOM.render(<Content />, $app);
